import ConversationVM from './conversation-vm';
export default function() {
  let self = this;
  self.conversations_mapping = {
    create: function(options) {
      let participants_mapping = {
        'participants': {
          create: function(options) {
            return ko.mapping.fromJS(_.extend({}, options.data, {_destroy: false}));
          }
        }
      };
      return new ConversationVM(ko.mapping.fromJS(_.extend({}, options.data, {messages: [], is_selected: false, _destroy: false}), participants_mapping), self);
    }
  };
  self.newConversation = ko.observable(false);
  self.startConversation = ko.observable();
  self.conversations = ko.observableArray([]);
  self.sortedConversations = ko.computed(function () {
    return self.conversations().sort(function (left, right) { return (left.updated_at() == right.updated_at()) ? 0 : (moment(left.updated_at()).isBefore(right.updated_at()) ? 1 : -1); });
  });
  self.mobileBreakPoint = 768;
  self.$window = $(window);
  self.windowWidth = ko.observable(self.$window.width());
  self.mobileView = ko.computed(function () {
    return self.windowWidth() <= self.mobileBreakPoint;
  });
  self.mobileView.subscribe(function () { });
  self.currentView = ko.observable('messages'); //or 'participants'
  self.searchQuery = ko.observable();
  self.searchIsSelected = ko.observable();
  self.conversationFilter = ko.observable('all');
  self.visibleConversations = ko.computed(function () {
    return _.filter(self.conversations(), function (conversation) {
      return !conversation._destroy();
    });
  });
  self.selectedConversation = ko.computed(function () {
    return self.newConversation() ? self.newConversation() : _.find(self.conversations(), function (conversation) {
      return !conversation._destroy() && conversation.is_selected();
    });
  });

  self.recipientSource = function() {
    let recipientSearch = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      limit: 10,
      remote: {
        url: Kadenze.Routes.search_messenger_participants_path({ query: '%QUERY' }),
        filter: function(recipients) {
          return _.map(recipients, function(recipient) { return { id: recipient.id, name: recipient.full_name, slug: recipient.slug, avatar: recipient.avatar.thumb.url, is_instructor: recipient['instructor?'] }; });
        },
        ajax: {
          dataType: 'json',
          dataAsJSON: true,
          contentType: 'application/json',
          beforeSend: function() {
            //TODO: Show progress indicator
          },
          complete: function() {
            //TODO: Hide progress indicator
          }
        }
      }
    });

    recipientSearch.initialize();

    return recipientSearch;
  };

  self.selectRecipient = function (participant, event) {
    self.selectedConversation().selectedSearchParticipants.push(participant);
    self.selectedConversation().resetParticipantSearch();
  };

  self.initRecipientTypeahead = function() {
    let recipientSource = self.recipientSource();

    ko.computed(function () {
      if (self.selectedConversation() && !_.isEmpty(self.selectedConversation().searchParticipant())) {
        recipientSource.get(self.selectedConversation().searchParticipant(), function (datums) {
          self.selectedConversation().searchParticipantResults(ko.mapping.fromJS(datums)());
        });
      }
    });

    let selector = self.mobileView() ? '.msngr-mobile-new-msg__footer' : '.msngr-main__reply';
    $(selector).off('click').on('click', function (e) {
      self.selectedConversation().resetParticipantSearch();
    });

    $('input.msg_recipients__field').focus();
    $('#js-messages-loader').hide();
  };

  self.initUI = function() {
    self.$window.resize(function(){
      self.windowWidth(self.$window.width());
    });

    if (!_.isEmpty(self.startConversation())) {
      self.goToConversationWith(self.startConversation());
      self.startConversation(null);
    }

  };

  self.createConversation = function () {
    if (self.mobileView()) {
      self.showMobileConv();
    }
    self.currentView('messages');

    let conversations_mapping = {
      create: function(options) {
        return new ConversationVM(_.extend({}, options.data, {messages: [], subject: 'New Message', is_selected: true, _destroy: false}), self);
      }
    };
    let new_conversation_data = JSON.parse($('#new_conversation_json').val() || '{}');
    let mapped_conversation = ko.mapping.fromJS(new_conversation_data, conversations_mapping);

    self.unselectAllConversations();
    self.newConversation(mapped_conversation);
    self.initRecipientTypeahead();
  };

  self.startConversationWith = function (participant) {
    if (self.mobileView())
      $(participant.$parent.participantMobileOptsEl).modal('hide');

    let response = new Kadenze.AjaxRequest({
      type: 'GET',
      url: Kadenze.Routes.with_messenger_conversations_path(participant.id())
    });

    response.done(function (data) {
      self.goToConversationWith(data);
    });
  };

  self.goToConversationWith = function (data) {
    if (_.isEmpty(data))
      return;

    //Find and navigate to conversation if it exists
    if (data.conversation && !isNaN(parseInt(data.conversation.id))) {
      let index = _.findIndex(self.visibleConversations(), function (conversation) {
        return conversation.id() == data.conversation.id;
      });
      if (index > -1) {
        self.selectConversation(self.visibleConversations()[index]);
      } else {
        //TODO: Fetch this conversation from the DB when conversations are paginated
      }
    } else {
      //Start a new conversation
      self.viewMessages();
      self.createConversation();
      if (!_.isEmpty(data.participant)) {
        self.selectedConversation().selectedSearchParticipants.push(ko.mapping.fromJS({id: data.participant.id, name: data.participant.full_name, avatar: data.participant.avatar, is_instructor: false}));
      }
      $('.msngr-main__reply textarea').focus();
    }
  };

  self.addConversation = function () {
    let existingConvIndex = _.findIndex(self.conversations(), function (conversation) {
      return conversation.id() == self.newConversation().id();
    });

    if (existingConvIndex > -1) {
      self.conversations()[existingConvIndex].deleteMessageCache();
      self.selectConversation(self.conversations()[existingConvIndex]);
    } else {
      self.conversations.unshift(self.newConversation());
      self.selectConversation(self.conversations()[0]);
    }
  };

  self.getConversations = function (params) {
    return new Kadenze.AjaxRequest({
      type: 'GET',
      url: Kadenze.Routes.messenger_conversations_path(params)
    });
  };

  self.showConversations = function() {
    let response = self.getConversations({type: self.conversationFilter()});

    response.done(function (data) {
      self.bindConversations(data);
    });
  };

  self.showNextConversation = function (index) {
    if (self.visibleConversations().length > 0) {
      let nextIndex = (self.visibleConversations().length <= index) ? (index - 1) : index;
      self.selectConversation(self.visibleConversations()[nextIndex]);
    }
  };

  self.searchConversations = function (item, event) {
    if (event.keyCode != 13)
      return true;

    let response = self.getConversations({query: self.searchQuery(), type: self.conversationFilter()});

    response.done(function (data) {
      self.bindConversations(data);
    });
  };

  self.bindConversations = function (data) {
    let mapped_conversations = ko.mapping.fromJS(data.conversations, self.conversations_mapping);
    self.conversations(mapped_conversations());

    if (self.conversations().length > 0) {
      if (!self.mobileView())
        self.selectConversation(self.conversations()[0]);
    } else {
      //TODO: Show no messages UI
    }

    clearTimeout(self.conversationPoll);
    self.watchForNewMessages();
  };

  self.watchForNewMessages = function () {
    let data = {};
    _.each(self.visibleConversations(), function (conversation) {
      let lastId = conversation.computedLastMessageId();
      if (lastId > -1) {
        data[conversation.id()] = conversation.computedLastMessageId();
      }
    });

    let response = new Kadenze.AjaxRequest({
      type: 'POST',
      data: {conversations: data},
      url: Kadenze.Routes.poll_messenger_conversations_path()
    });

    response.done(function (data) {
      _.each(_.keys(data.new), function (conversation_id) {
        let conversation = data.new[conversation_id];
        let mapped_conversation = ko.mapping.fromJS(conversation, self.conversations_mapping);
        self.conversations.unshift(mapped_conversation);
      });

      _.each(_.keys(data.updates), function (conversation_id) {
        let messages = data.updates[conversation_id].messages;
        if (messages.length > 0) {
          let conversation = _.find(self.conversations(), function (conversation) {
            return conversation.id() == conversation_id;
          });

          if (conversation) {
            conversation.addMessages(messages);
          }
        }
      });
    });

    response.always(function () {
      self.conversationPoll = setTimeout(self.watchForNewMessages, 1000);
    });
  };

  self.unselectAllConversations = function () {
    _.each(self.conversations(), function (conversation) {
      conversation.unselect();
    });
  };

  self.selectConversation = function (item, event) {
    let select = function () {
      self.unselectAllConversations();
      self.newConversation(false);
      self.viewMessages();
      self.refreshURL();
      item.select();

      if (event && self.mobileView()) {
        self.showMobileConv();
      }
    };

    if (!(item.is_selected() && (self.currentView() === 'messages'))) {
      select();
    }
  };

  self.updateParticipantInAllConversations = function (participant) {
    _.each(self.visibleConversations(), function (conversation) {
      let matching_participant = _.find(conversation.visibleParticipants(), function (conv_participant) {
        return conv_participant.id() == participant.id();
      });
      if (matching_participant) {
        matching_participant.is_blocked(participant.is_blocked());
      }
    });
  };

  self.viewParticipants = function () {
    self.currentView('participants');
  };

  self.selectAndViewParticipants = function (item, event) {
    self.unselectAllConversations();
    self.newConversation(false);
    item.select();
    self.currentView('participants');
  };

  self.viewMessages = function () {
    self.currentView('messages');
    if (self.selectedConversation()) {
      $('a.embed').oembed();
      self.selectedConversation().scrollToBottom();
    }
  };

  self.showMobileConvList = function () {
    $('#msngrNewMsgBtn_mobile').removeClass('msngr-nav__add-btn--hidden');
    let $msngr = $('#msngr');
    TweenLite.to( $msngr, 0.4, { left: 0 } );
    $('#main-nav').removeClass('mobile-nav--hidden');
  };

  self.showMobileConv = function () {
    $('#msngrNewMsgBtn_mobile').addClass('msngr-nav__add-btn--hidden');
    let $msngr = $('#msngr');
    TweenLite.to( $msngr, 0.4, { left: '-100vw' } );
    $('#main-nav').addClass('mobile-nav--hidden');
  };

  self.refreshURL = function (params) {
    let url = Kadenze.Routes.messenger_overview_path();
    history.replaceState($.pjax.state, null, url);
  };

  const __construct = function(that) {
    console.log('constructor called for CommonMessengerOverviewVM');

    that.conversationFilter.subscribe(function () {
      self.searchQuery('');
      self.showConversations();
    });

    let conversations_data = JSON.parse($('#conversations_json').val() || '[]');
    self.bindConversations(conversations_data);

    let start_conversation_data = JSON.parse($('#start_conversation_json').val() || '{}');
    self.startConversation(start_conversation_data);
  }(this);
}


